module.exports = __webpack_public_path__ + "static/media/lights_103.3df540cd.ico";